import { render } from "./VersusChoice.vue?vue&type=template&id=f9708d74&scoped=true&ts=true"
import script from "./VersusChoice.vue?vue&type=script&lang=ts"
export * from "./VersusChoice.vue?vue&type=script&lang=ts"

import _style_0 from "./VersusChoice.vue?vue&type=style&index=0&id=f9708d74&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-f9708d74"]])

export default __exports__